<template>
  <div class="container container-fluid">
    <div class="d-flex justify-content-between align-items-center">
      <!-- INPUT PARA BUSCAR -->
      <div class="col-md-3 pt-4">
        <input
          v-model="searchTable"
          type="text"
          class="form-control"
          placeholder="Buscar en la tabla..."
        />
      </div>
    </div>

    <div class="table-container-scrollable-company my-3">
      <table
        class="table table-striped table-hover table-bordered text-center table-rounded mt-2"
      >
        <thead class="table-secondary">
          <tr>
            <th>
              <div class="d-flex justify-content-between align-items-center text-center">
                <div
                  @click="sortColumn('id')"
                  :class="{
                    'sort-asc': sortOrder.id === 1,
                    'sort-desc': sortOrder.id === -1,
                  }"
                ></div>

                <div class="">ID</div>
              </div>
            </th>

            <th>
              <div class="d-flex align-items-center text-center">
                <div
                  @click="sortColumn('name')"
                  :class="{
                    'sort-asc': sortOrder.name === 1,
                    'sort-desc': sortOrder.name === -1,
                  }"
                ></div>

                <div class="mx-auto">Nombre</div>
              </div>
            </th>

            <th>Email</th>
            <th>Formularios</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in filteredData" :key="index">
            <td>{{ row.id }}</td>
            <td>{{ row.name }}</td>
            <td>
              <div 
              v-html="row.emailsFormatted
              ">
              </div>
            </td>
            <!-- HACER LINK -->
            <td>
              <router-link
                v-for="(form, index) in row.companiesForms"
                :key="index"
                class="btn btn-block btn-secondary my-1"
                :to="{ name: 'FormPublic', params: { slug: row.slug, id: form.id } }"
              >
                {{`${row.idSlug}${form.id}` }}
              </router-link>
            </td>
            <td>
              <!-- <div
                class="btn btn-block btn-custom"
                href="#"
                title="NO DISPONIBLE"
              >
                Editar
              </div> -->
              <router-link
                class="btn btn-block btn-custom"
                href="#"
                :to="{ name: 'EditCompany', params: { id: row.id } }"
              >
                Editar
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import { ref, computed, watch } from "vue";

export default {
  name: "TableCompanies",
  props: {
    dataDATA: Array,
  },
  setup(props) {
    const searchTable = ref("");
    const url = `${process.env.VUE_APP_URL_LINK}`;
    const form = `${process.env.VUE_APP_URL_FORMULARIOS}`;

    const sortOrder = ref({
      id: 1,
      name: 1,
    });
    
    const tableData = ref(props.dataDATA || []);
    const formatEmails = (emails) => {
      return emails.split(',').join('<br>');
    };


    const filteredData = computed(() => {
      const search = searchTable.value.toLowerCase();
      return tableData.value.map((row) => {
        row.idSlug = `${url}${row.slug}${form}`;
        row.emailsFormatted = formatEmails(row.emails);
        return row;
      }).filter((row) => {
        return Object.values(row)
          .filter((value) => value !== null && value !== undefined)
          .some((value) => value.toString().toLowerCase().includes(search));
      });
    });

    const sortColumn = (column) => {
      sortOrder.value[column] = -sortOrder.value[column];
      tableData.value.sort((a, b) => {
        return (a[column] > b[column] ? 1 : -1) * sortOrder.value[column];
      });
    };

    const editCompany = async (id) => {

      try {
        //const response = await apiArmas.getEntregaPersonalPdf({ id: id } );

        if (response.headers['content-type'] === 'application/pdf') {

          const blob = new Blob([response.data], { type: 'application/pdf' });

          const url = window.URL.createObjectURL(blob);

          window.open(url, '_blank');

          window.URL.revokeObjectURL(url);
        } else {
          console.error('La respuesta no es un PDF válido.');
        }
      } catch (error) {
        console.error(error);
      }
    };

    return {
      filteredData,
      tableData,
      editCompany,
      searchTable,
      sortOrder,
      sortColumn,
    };
  },
};
</script>
